import * as C from '../models/medals/constants';


const InitialState = {
    date: {},
    timestamp: (new Date()).getTime()
};

export default (state = InitialState, action) => {
    if (action.type && C[action.type]) {
        return {
            state: action.type,
            data: action.data || {}
        };
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/medals.reducer.js